export type BusinessType = "hotel" | "restaurant" | "clinic" | "spa_salon" | "events_venue" | "other";

export const BUSINESS_TYPE_OPTIONS: { value: BusinessType; label: string }[] = [
  { value: "hotel", label: "Hotel" },
  { value: "restaurant", label: "Restaurant" },
  { value: "clinic", label: "Clinic / Doctor" },
  { value: "spa_salon", label: "Spa / Salon" },
  { value: "events_venue", label: "Events / Venue" },
  { value: "other", label: "Other" },
];

export const MAX_BUSINESS_DESCRIPTION = 200;
export const MAX_ASSISTANT_INSTRUCTIONS = 1000;

const isBusinessType = (value: unknown): value is BusinessType =>
  BUSINESS_TYPE_OPTIONS.some((option) => option.value === value);

/** The saved business type, else Hotel for the hotel (or no) profile and Other for the general one. */
export function businessTypeOf(
  data: { business_type?: string; businessType?: string; assistant_profile?: string; assistantProfile?: string } | null | undefined,
): BusinessType {
  const saved = String(data?.business_type ?? data?.businessType ?? "").trim().toLowerCase().replace(/[\s-]+/g, "_");
  if (isBusinessType(saved)) return saved;
  return (data?.assistant_profile ?? data?.assistantProfile) === "general" ? "other" : "hotel";
}

/** One line of plain text, as the chatbot reads it. */
export function cleanDescription(value: unknown): string {
  // eslint-disable-next-line no-control-regex
  return String(value ?? "").replace(/[\u0000-\u001f\u007f-\u009f]/g, " ").split(/\s+/).filter(Boolean).join(" ");
}

/**
 * The business settings saved with the property. A hotel without a
 * description stores no ``business_type`` so the chatbot keeps its existing
 * prompts; any other type also sets the matching assistant profile.
 */
export function businessPayload(businessType: BusinessType, description: string): {
  assistant_profile: "hotel" | "general";
  business_type?: BusinessType;
  business_description: string;
} {
  const business_description = cleanDescription(description);
  const assistant_profile = businessType === "hotel" ? "hotel" : "general";
  if (businessType === "hotel" && !business_description) return { assistant_profile, business_description };
  return { assistant_profile, business_type: businessType, business_description };
}
